import script from "./DefaultCallButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultCallButton.vue?vue&type=script&setup=true&lang=js"

import "./DefaultCallButton.vue?vue&type=style&index=0&id=0015179e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0015179e"]])

export default __exports__